import { Link } from "react-router-dom";
import { useApp } from "../context/AppContext";
import { fmtPrice } from "../lib/i18n";

const DISCOUNT_MULT = 1.25; // displayed "original" price is 25% higher; current = sale price

export const ProductCard = ({ product }) => {
    const { lang, t } = useApp();
    const name = lang === "ar" ? product.name_ar : product.name_en;
    const category = lang === "ar" ? product.category_ar : product.category_en;

    let priceDisplay = null;
    let originalPrice = null;
    let currentPrice = null;
    let prefix = "";
    if (product.coming_soon) {
        priceDisplay = lang === "ar" ? "قريباً" : "Coming Soon";
    } else if (product.quote_only) {
        priceDisplay = lang === "ar" ? "السعر حسب الطلب" : "Price on Request";
    } else if (product.variants && product.variants.length > 0) {
        currentPrice = Math.min(...product.variants.map((v) => v.price));
        originalPrice = Math.round(currentPrice * DISCOUNT_MULT);
        prefix = `${t.product.from} `;
    } else {
        currentPrice = product.base_price || 0;
        originalPrice = Math.round(currentPrice * DISCOUNT_MULT);
    }

    return (
        <Link
            to={`/products/${product.slug}`}
            data-testid={`product-card-${product.slug}`}
            className="group block"
        >
            <div className="img-zoom relative aspect-[4/5] bg-[#141414] border border-[#D4AF37]/20 overflow-hidden">
                <img
                    src={product.image}
                    alt={name}
                    className="absolute inset-0 w-full h-full object-cover object-center opacity-95 group-hover:opacity-100"
                    onError={(e) => { e.target.src = "https://images.unsplash.com/photo-1535016120720-40c646be5580"; }}
                />
                <div className="absolute inset-x-0 bottom-0 h-1/3 bg-gradient-to-t from-black/90 to-transparent" />
                <div className="absolute top-2 start-2 sm:top-4 sm:start-4 overline text-[10px] sm:text-xs bg-black/40 backdrop-blur-sm px-2 py-0.5 sm:px-3 sm:py-1 border border-[#D4AF37]/30">
                    {category}
                </div>
                {product.coming_soon && (
                    <div className="absolute top-2 end-2 sm:top-4 sm:end-4 overline text-[10px] sm:text-xs bg-[#D4AF37] text-black px-2 py-0.5 sm:px-3 sm:py-1 font-semibold">
                        {lang === "ar" ? "قريباً" : "Coming Soon"}
                    </div>
                )}
                {!product.coming_soon && !product.quote_only && (
                    <div data-testid={`discount-badge-${product.slug}`} className="absolute top-2 end-2 sm:top-4 sm:end-4 text-[10px] sm:text-xs bg-[#D4AF37] !text-black px-2 py-0.5 sm:px-3 sm:py-1 font-bold tracking-wider">
                        {lang === "ar" ? "خصم 25٪" : "-25% OFF"}
                    </div>
                )}
            </div>
            <div className="pt-3 sm:pt-5">
                <h3 className="section-heading text-base sm:text-xl md:text-2xl text-white group-hover:text-[#D4AF37] transition-colors leading-tight">
                    {name}
                </h3>
                <div className="flex items-center justify-between mt-1.5 sm:mt-2 gap-2">
                    {priceDisplay ? (
                        <span className="price-display text-sm sm:text-lg text-[#D4AF37]">{priceDisplay}</span>
                    ) : (
                        <span className="flex items-baseline gap-1.5 sm:gap-2 flex-wrap">
                            <span className="price-display text-sm sm:text-lg text-[#D4AF37]">
                                {prefix}{fmtPrice(currentPrice, lang)}
                            </span>
                            <span className="price-display text-xs sm:text-sm text-white/40 line-through decoration-white/40">
                                {fmtPrice(originalPrice, lang)}
                            </span>
                        </span>
                    )}
                    <span className="hidden sm:inline text-xs text-white/50 tracking-widest shrink-0">
                        {lang === "ar" ? "عرض ←" : "VIEW →"}
                    </span>
                </div>
            </div>
        </Link>
    );
};
